import * as Yup from 'yup';
import { cpfValidator } from '../../../utils/CpfValidator';

export const PasswordRecoveryUnimedCampinasValidation = Yup.object().shape({
  dataNascimento: Yup.string().required('Insira um Data de Nascimento válida e correta'),
  cpf: Yup.string().test('cpf-valid', 'Insira um CPF válido e correto', function (value) {
    return cpfValidator(value || '');
  }).required('Insira um CPF válido e correto'),
})
